import { IAppState } from './models/state/IAppState';

export const InitialState: IAppState = {
    soraya: {
        
    }
}